var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0 24 24 0 24z",
    transform: "translate(-249 -3280) translate(0 2867) translate(248 410)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.2,
    fillRule: "nonzero",
    d: "M22.162 5.656c-.763.338-1.573.56-2.402.658.874-.523 1.528-1.345 1.84-2.314-.82.488-1.719.83-2.656 1.015-1.294-1.385-3.358-1.726-5.029-.832-1.67.895-2.531 2.801-2.097 4.646-3.363-.169-6.496-1.757-8.62-4.37-.372.638-.567 1.364-.566 2.103 0 1.45.738 2.731 1.86 3.481-.664-.02-1.313-.2-1.894-.523v.052c0 1.991 1.404 3.706 3.355 4.101-.616.167-1.263.192-1.89.072.547 1.704 2.117 2.872 3.907 2.905-1.752 1.376-3.98 2-6.191 1.732 1.912 1.23 4.137 1.882 6.41 1.88 7.693 0 11.9-6.373 11.9-11.9 0-.18-.005-.362-.013-.54.819-.592 1.526-1.325 2.087-2.165l-.001-.001z",
    transform: "translate(-249 -3280) translate(0 2867) translate(248 410)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.761840a9ecbe25e860dca6ebd3796df7.svg";
export { ForwardRef as ReactComponent };